var _rect, _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCalender(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 48,
    viewBox: "0 0 49 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.824219,
    width: 47.3491,
    height: 47.3544,
    rx: 8,
    fill: "#ECF8F0"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.7502 15.56V14C29.7502 13.59 29.4102 13.25 29.0002 13.25C28.5902 13.25 28.2502 13.59 28.2502 14V15.5H21.7502V14C21.7502 13.59 21.4102 13.25 21.0002 13.25C20.5902 13.25 20.2502 13.59 20.2502 14V15.56C17.5502 15.81 16.2402 17.42 16.0402 19.81C16.0202 20.1 16.2602 20.34 16.5402 20.34H33.4602C33.7502 20.34 33.9902 20.09 33.9602 19.81C33.7602 17.42 32.4502 15.81 29.7502 15.56Z",
    fill: "#2E1834"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M34 22.84V24.58C34 25.19 33.46 25.66 32.86 25.56C32.58 25.52 32.29 25.49 32 25.49C28.97 25.49 26.5 27.96 26.5 30.99C26.5 31.45 26.68 32.09 26.87 32.67C27.09 33.32 26.61 33.99 25.92 33.99H21C17.5 33.99 16 31.99 16 28.99V22.83C16 22.28 16.45 21.83 17 21.83H33C33.55 21.84 34 22.29 34 22.84Z",
    fill: "#2E1834"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M32 27C29.79 27 28 28.79 28 31C28 31.75 28.21 32.46 28.58 33.06C29.27 34.22 30.54 35 32 35C33.46 35 34.73 34.22 35.42 33.06C35.79 32.46 36 31.75 36 31C36 28.79 34.21 27 32 27ZM34.07 30.57L31.94 32.54C31.8 32.67 31.61 32.74 31.43 32.74C31.24 32.74 31.05 32.67 30.9 32.52L29.91 31.53C29.62 31.24 29.62 30.76 29.91 30.47C30.2 30.18 30.68 30.18 30.97 30.47L31.45 30.95L33.05 29.47C33.35 29.19 33.83 29.21 34.11 29.51C34.39 29.81 34.37 30.28 34.07 30.57Z",
    fill: "#2E1834"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M21.5 27C21.24 27 20.98 26.89 20.79 26.71C20.61 26.52 20.5 26.26 20.5 26C20.5 25.74 20.61 25.48 20.79 25.29C21.02 25.06 21.37 24.95 21.7 25.02C21.76 25.03 21.82 25.05 21.88 25.08C21.94 25.1 22 25.13 22.06 25.17C22.11 25.21 22.16 25.25 22.21 25.29C22.39 25.48 22.5 25.74 22.5 26C22.5 26.26 22.39 26.52 22.21 26.71C22.16 26.75 22.11 26.79 22.06 26.83C22 26.87 21.94 26.9 21.88 26.92C21.82 26.95 21.76 26.97 21.7 26.98C21.63 26.99 21.56 27 21.5 27Z",
    fill: "#2E1834"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M25 27C24.74 27 24.48 26.89 24.29 26.71C24.11 26.52 24 26.26 24 26C24 25.74 24.11 25.48 24.29 25.29C24.67 24.92 25.34 24.92 25.71 25.29C25.89 25.48 26 25.74 26 26C26 26.26 25.89 26.52 25.71 26.71C25.52 26.89 25.26 27 25 27Z",
    fill: "#2E1834"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M21.5 30.5C21.24 30.5 20.98 30.39 20.79 30.21C20.61 30.02 20.5 29.76 20.5 29.5C20.5 29.24 20.61 28.98 20.79 28.79C20.89 28.7 20.99 28.63 21.12 28.58C21.49 28.42 21.93 28.51 22.21 28.79C22.39 28.98 22.5 29.24 22.5 29.5C22.5 29.76 22.39 30.02 22.21 30.21C22.02 30.39 21.76 30.5 21.5 30.5Z",
    fill: "#2E1834"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalender);
export default __webpack_public_path__ + "static/media/calender.334b3b6800f48a6cb6b15a38edcc53d1.svg";
export { ForwardRef as ReactComponent };